import { Component } from '@angular/core';
import { finalize } from 'rxjs';
import { ClienteUnicoAppDto, ClienteUnicoServiceProxy } from '../services/service-proxy/service-proxies';
import { AppService } from '../services/app.service';

/** Una opción con interruptor. */
interface Opcion {
  clave : string;
  titulo : string;
  detalle : string;
  activo : boolean;
}

@Component({
  selector: 'app-preferencias',
  templateUrl: './preferencias.component.html',
  styleUrls: ['./preferencias.component.scss']
})
export class PreferenciasComponent {

  isLoading = false;
  model? : ClienteUnicoAppDto | null;

  /**
   * ⚠️ Estos interruptores NO se guardan en ningún lado todavia. No existe
   * campo ni endpoint para el opt-in de comunicaciones (se investigo: ni el
   * cliente ni el sistema Vet lo tienen). La pantalla queda presentada y el
   * estado vive solo en memoria mientras dura la visita. Cuando exista el
   * backend, se conecta acá.
   *
   * Los valores por defecto son los que trae el prototipo.
   */
  queRecibir : Opcion[] = [
    { clave: 'recordatorios', titulo: 'Recordatorios de tus mascotas', detalle: 'Vacunas, antiparasitarios y controles.', activo: true },
    { clave: 'puntos',        titulo: 'Novedades de tus puntos',        detalle: 'Cuando subís de nivel y cuando algo está por vencer.', activo: true },
    { clave: 'ofertas',       titulo: 'Ofertas y promociones',          detalle: 'Descuentos de la tienda, no del Club.', activo: false }
  ];

  porDonde : Opcion[] = [
    { clave: 'email',    titulo: 'Correo electrónico', detalle: '', activo: true },
    // El telefono no viene en ClienteUnicoAppDto (solo en el DTO de Mis datos,
    // que no esta cacheado aca), asi que no se muestra el numero: no se inventa
    // ni se hace una llamada extra solo para esto.
    { clave: 'whatsapp', titulo: 'WhatsApp',           detalle: 'Al número de tu cuenta.', activo: true },
    { clave: 'sms',      titulo: 'Mensajes de texto',  detalle: 'Solo para cosas urgentes.', activo: false }
  ];

  constructor(private clienteUnicoService : ClienteUnicoServiceProxy,
              public appService : AppService) {}

  ngOnInit() {

    const idUnico = this.appService.idUnico!;

    this.model = this.appService.getClienteAppData(idUnico);
    if (this.model) { this.completarCanales(); return; }

    this.isLoading = true;
    this.clienteUnicoService
        .getForApp(idUnico, null)
        .pipe(finalize(() => this.isLoading = false))
        .subscribe(respuesta => {
          this.model = respuesta;
          this.appService.saveClienteAppData(this.model);
          this.completarCanales();
        });
  }

  /** El correo del canal es el dato real del cliente. */
  private completarCanales() {
    const email = this.model?.emailPrincipal ?? '';
    const o = this.porDonde.find(x => x.clave === 'email');
    if (o) o.detalle = email;
  }

  /** Cambia el interruptor. No persiste: solo estado en memoria. */
  alternar(opcion : Opcion) {
    opcion.activo = !opcion.activo;
  }
}
